export enum CollapseItems {
  COMPANY_DETAILS = 'COMPANY_DETAILS',
  COMPANY_INFO = 'COMPANY_INFO',
  COMPANY_STRUCTURE = 'COMPANY_STRUCTURE',
  OWNERS = 'OWNERS',
}

export enum CollapseKYCItems {
  BASIC_INFO = 'BASIC_INFO',
  BIOMETRIC_CHECK = 'BIOMETRIC_CHECK',
  RESIDENCE_ADDRESS = 'RESIDENCE_ADDRESS',
  BUSINESS_INFO = 'BUSINESS_INFO',
  SOURCE_OF_WEALTH = 'SOURCE_OF_WEALTH',
}

export enum PersonType {
  Physical = 'physical',
  Legal = 'legal',
}

export enum CompanyType {
  SARL = 'sarl',
  SARL_S = 'sarl-s',
}

export const ACCOUNTING_PLANS = {
  1: '0-€75K',
  2: '€75K-€150K',
  3: '€150K-€300K',
  4: '€300K-€500K',
  5: '€500K-€1000K',
  6: '€1000K-€2000K',
  7: '€2000K+',
} as const;
